<template>
  <b-card :class="'border-left-' + variant">
    <div class="top">
      <slot name="top"/>
    </div>
    <div class="row no-gutters align-items-center">
      <div class="col mr-2">
        <slot>
          <div :class="'text-xs font-weight-bold text-uppercase mb-1 text-' + variant">
            {{ text }}
          </div>
          <div v-if="value" class="h5 mb-0 font-weight-bold text-gray-800">
            {{ value }} <small>{{ valueDescription }}</small>
          </div>
        </slot>
      </div>
      <div class="col-auto">
        <slot name="icon">
          <i :class="{
            'fas': true,
            ['fa-' + icon]: true,
            ['text-' + variant]: true,
            'fa-2x': !smallScreen
          }"/>
        </slot>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "LittleCard",
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    text: {
      type: String,
      default: null
    },
    value: {
      type: String | Number,
      default: null
    },
    valueDescription: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'cogs'
    }
  },
  computed: {
    smallScreen() {
      return window.innerWidth <= 680
    }
  }
}
</script>

<style scoped>

</style>
